module.exports = __webpack_public_path__ + "img/ico1.93f7f063.png";